import { render, staticRenderFns } from "./printcaigoufukuan.vue?vue&type=template&id=70db2391&scoped=true&"
import script from "./printcaigoufukuan.vue?vue&type=script&lang=js&"
export * from "./printcaigoufukuan.vue?vue&type=script&lang=js&"
import style0 from "./printcaigoufukuan.vue?vue&type=style&index=0&id=70db2391&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70db2391",
  null
  
)

export default component.exports